export default __webpack_public_path__ + "static/antadir-a2f0bc2499e2e4ed9c900a5a0a5b68f6.png";